// src/components/AttendanceTrendLine.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ReactApexChart from 'react-apexcharts';
import { API_BASE_URL } from '../..//config'; // keep your existing path

const AttendanceTrendLine = () => {
  const [categories, setCategories] = useState([]); // dates (YYYY-MM-DD)
  const [series, setSeries] = useState([
    { name: 'Present', data: [] },
    { name: 'Total',   data: [] },
    // If you also want % line, uncomment below and options.yaxis[1]
    // { name: '% Present', data: [], type: 'line' },
  ]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const load = async () => {
      try {
        // Adjust to your actual route (e.g. /api/attendance/daily-split)
        const url = `${API_BASE_URL}/attendanceDailySplitLastMonth`;
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
        });
        if (res.data?.status !== 'success') throw new Error('Unexpected response');

        const rows = (res.data.data || []).sort(
          (a, b) => new Date(a.shift_date) - new Date(b.shift_date)
        );

        setCategories(rows.map(r => r.shift_date));
        setSeries([
          { name: 'Present', data: rows.map(r => Number(r.present || 0)) },
          { name: 'Total',   data: rows.map(r => Number(r.total   || 0)) },
          // { name: '% Present', data: rows.map(r => Number(r.percent || 0)) },
        ]);
      } catch (e) {
        console.error(e);
        setErr(e?.response?.data?.message || e?.message || 'Failed to load data');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <div>Loading…</div>;
  if (err) return <div style={{ color: 'crimson' }}>{err}</div>;
  if (!categories.length) return <div>No data in the last month.</div>;

  const options = {
    chart: { type: 'line', toolbar: { show: false } },
    colors: ['#1769aa', '#9e9e9e'], // Present, Total
    stroke: { curve: 'smooth', width: 2 },
    markers: { size: 3 },
    dataLabels: { enabled: false },
    xaxis: {
      type: 'category',
      categories,
      title: { text: 'Date' },
      labels: { rotate: -30, trim: true },
    },
    yaxis: [
      {
        title: { text: 'Employees' },
        min: 0,
        decimalsInFloat: 0,
      },
      // If using % line, add a right axis:
      // {
      //   opposite: true,
      //   max: 100, min: 0,
      //   title: { text: '% Present' },
      //   labels: { formatter: v => `${v}%` },
      // },
    ],
    tooltip: {
      shared: true,
      intersect: false,
      y: { formatter: (val, { seriesIndex }) =>
        seriesIndex === 2 ? `${val}%` : `${val} employees` },
    },
    legend: { position: 'top' },
  };

  return (
    <div>
      <h4 className="mb-2">Attendance Trend (Last 30 Days)</h4>
      <ReactApexChart options={options} series={series} type="line" height={360} />
    </div>
  );
};

export default AttendanceTrendLine;
